export class ErrorBase {
  public message: any;

  constructor(message: any | undefined) {
    this.message = message;
  }
}
